import { render, staticRenderFns } from "./ConfigurationPage.vue?vue&type=template&id=a2a9738e&scoped=true&"
import script from "./ConfigurationPage.vue?vue&type=script&lang=js&"
export * from "./ConfigurationPage.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationPage.vue?vue&type=style&index=0&id=a2a9738e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a9738e",
  null
  
)

export default component.exports